export const rtlLocales = new Set(['he', 'ar-EG']);
